import ShowInactiveLeads from './ShowInactiveLeads.component';

export default ShowInactiveLeads;